"use client"

import { Badge } from "@/components/ui/badge"
import { Label } from "@/components/ui/label"
import { useDestinationValueFormatter } from "@/hooks/use-destination-value-formatter"
import type { SingleTestResult } from "@/types/ui"
import { useTranslation } from "@/hooks/use-translation"
import type { TranslationKey } from "@/lib/translations"

interface TestResultsSingleProps {
  results: SingleTestResult
}

export function TestResultsSingle({ results }: TestResultsSingleProps) {
  const { t } = useTranslation()
  const { formatDestinationValue } = useDestinationValueFormatter()

  return (
    <div className="space-y-4">
      <h4 className="font-medium">{t("testing.results.title")}</h4>
      <div className="border rounded-md p-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <Label className="text-sm font-medium">{t("testing.sourceField.entityType")}</Label>
            <p className="text-sm">{results.entityType}</p>
          </div>
          <div>
            <Label className="text-sm font-medium">{t("testing.sourceField.entityId")}</Label>
            <p className="text-sm">{results.entityId}</p>
          </div>
          <div>
            <Label className="text-sm font-medium">{t("testing.sourceField.sourceField")}</Label>
            <p className="text-sm font-mono">{results.sourceField}</p>
          </div>
          <div>
            <Label className="text-sm font-medium">{t("testing.singleResults.status")}</Label>
            <p className={`text-sm font-medium ${results.success ? "" : "text-destructive"}`}>
              {t((results.success ? "testing.singleResults.success" : "testing.singleResults.failed"))}
            </p>
          </div>
          {results.success && (
            <div className="col-span-2">
              <Label className="text-sm font-medium">{t("testing.singleResults.sourceValue")}</Label>
              <pre className="text-sm font-mono bg-muted p-2 rounded">{formatDestinationValue(results.sourceValue)}</pre>
            </div>
          )}
          {results.error && (
            <div className="col-span-2">
              <Label className="text-sm font-medium text-destructive">{t("testing.singleResults.error")}</Label>
              <p className="text-sm text-destructive">{results.error}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
} 